/* Jhilke wishlist (speed pass 2026-10-01, replaces the Magic Wishlist app).
   Saved prints live in this browser (localStorage: [{h: handle, v: variant id or null}], LO 15 Oct 2026; the
   old plain-handle list is still read). Hearts are rendered by Liquid
   (snippets/jhilke-wishlist-button.liquid) so nothing shifts; this file only flips their state and, on
   /pages/wishlist (sections/jhilke-wishlist.liquid), fetches the saved products and lists them.
   No request is made on any other page. */
(function () {
  var KEY = 'jh-wishlist';
  var german = (document.documentElement.lang || '').toLowerCase().indexOf('de') === 0;
  var T = german ? {
    save: 'Auf die Wunschliste: ', remove: 'Von der Wunschliste entfernen: ', saved: 'Gemerkt',
    removeBtn: 'Entfernen', soldOut: 'Ausverkauft', count1: '1 Print gemerkt', countN: ' Prints gemerkt',
    copied: 'Link kopiert', shared: 'Geteilte Wunschliste', saveAll: 'Alle merken',
    removed: 'Entfernt: ', undo: 'Rückgängig', back: 'Wieder auf der Wunschliste: ', copyThis: 'Diesen Link kopieren: ',
    addCart: 'In den Warenkorb', addAll: 'Alle in den Warenkorb', chooseSize: 'Größe wählen',
    added: 'Im Warenkorb: ', addedAll: 'Im Warenkorb: alle Prints', failed: 'Das hat nicht geklappt. Bitte noch einmal versuchen.'
  } : {
    save: 'Save to wishlist: ', remove: 'Remove from wishlist: ', saved: 'Saved',
    removeBtn: 'Remove', soldOut: 'Sold out', count1: '1 print saved', countN: ' prints saved',
    copied: 'Link copied', shared: 'A shared wishlist', saveAll: 'Save all',
    removed: 'Removed: ', undo: 'Undo', back: 'Back on your wishlist: ', copyThis: 'Copy this link: ',
    addCart: 'Add to cart', addAll: 'Add all to cart', chooseSize: 'Choose size',
    added: 'Added to cart: ', addedAll: 'Added to cart: all prints', failed: 'Could not add. Please try again.'
  };

  var HANDLE_RE = /^[a-z0-9][a-z0-9_-]*$/i;
  var VARIANT_RE = /^\d{1,20}$/;
  var MAX = 60;

  // One entry is {h: handle, v: variant id string or null}. Anything invalid is dropped; one entry per handle.
  function cleanVariant(v) {
    if (v == null) return null;
    v = String(v).trim();
    return VARIANT_RE.test(v) ? v : null;
  }
  function norm(x) {
    var h, v = null;
    if (typeof x === 'string') h = x;
    else if (x && typeof x === 'object' && typeof x.h === 'string') { h = x.h; v = cleanVariant(x.v); }
    else return null;
    h = h.trim();
    return HANDLE_RE.test(h) ? { h: h, v: v } : null;
  }
  function normList(arr) {
    var seen = {}, out = [];
    (Array.isArray(arr) ? arr : []).forEach(function (x) {
      var e = norm(x);
      if (!e || seen[e.h.toLowerCase()]) return;
      seen[e.h.toLowerCase()] = true;
      out.push(e);
    });
    return out.slice(0, MAX);
  }
  // Share link format: handle:variantId,handle2,handle3:variantId (strict; bad pieces are dropped).
  function parseShare(str) {
    return normList(String(str || '').split(',').map(function (part) {
      var bits = part.trim().split(':');
      if (bits.length > 2) return null;
      var e = norm(bits[0]);
      if (!e) return null;
      if (bits.length === 2) { e.v = cleanVariant(bits[1]); if (!e.v) return null; }
      return e;
    }));
  }
  function buildShare(list) {
    return list.map(function (e) { return e.v ? e.h + ':' + e.v : e.h; }).join(',');
  }
  function read() {
    try { return normList(JSON.parse(localStorage.getItem(KEY) || '[]')); } catch (e) { return []; }
  }
  function write(list) {
    list = normList(list);
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('jh:wishlist', { detail: { items: list } }));
  }
  function indexOfHandle(list, handle) {
    for (var i = 0; i < list.length; i++) if (list[i].h === handle) return i;
    return -1;
  }
  function has(handle) { return indexOfHandle(read(), handle) !== -1; }
  // Heart press. Returns 'added', 'removed' or 'updated' (product page, a different variant is now chosen).
  function toggle(handle, variant, onProductPage) {
    var list = read(), i = indexOfHandle(list, handle);
    if (i === -1) { list.unshift({ h: handle, v: variant }); write(list); return 'added'; }
    if (onProductPage && variant && list[i].v !== variant) { list[i].v = variant; write(list); return 'updated'; }
    list.splice(i, 1);
    write(list);
    return 'removed';
  }
  // The variant chosen on the product page: the product form's hidden id (it follows the picker), else ?variant=.
  function pageVariant(btn, handle) {
    var input = null, form = btn.closest('form');
    if (form) input = form.querySelector('input[name="id"]');
    if (!input) {
      var comps = document.querySelectorAll('product-form-component');
      for (var i = 0; i < comps.length && !input; i++) {
        if ((comps[i].getAttribute('data-product-url') || '').indexOf('/products/' + handle) !== -1) input = comps[i].querySelector('input[name="id"]');
      }
    }
    var v = input ? cleanVariant(input.value) : null;
    if (!v) { try { v = cleanVariant(new URLSearchParams(location.search).get('variant')); } catch (e) {} }
    return v;
  }

  function paint(btn) {
    var on = has(btn.getAttribute('data-jh-wish'));
    var title = btn.getAttribute('data-jh-wish-title') || '';
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', T.save + title); // fixed name; aria-pressed says whether it is saved
    var label = btn.querySelector('[data-jh-wish-label]');
    if (label) label.textContent = on ? (btn.getAttribute('data-jh-wish-on') || T.saved) : (btn.getAttribute('data-jh-wish-off') || '');
  }
  function paintAll(root) {
    (root || document).querySelectorAll('[data-jh-wish]').forEach(paint);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-jh-wish]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-jh-wish');
    var onProductPage = !btn.classList.contains('jh-wish--card');
    var result = toggle(handle, onProductPage ? pageVariant(btn, handle) : null, onProductPage);
    var added = result === 'added';
    paintAll();
    // Custom event for the web pixel (the app used to log saves in its own dashboard).
    if (added && window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
      try { Shopify.analytics.publish('jh_wishlist_add', { handle: handle }); } catch (err) {}
    }
  }, true);
  document.addEventListener('jh:wishlist', function () { paintAll(); });
  window.addEventListener('storage', function (e) { if (e.key === KEY) paintAll(); });

  // Cards added later (infinite scroll, quick add, recommendations) arrive without state.
  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      for (var j = 0; j < records[i].addedNodes.length; j++) {
        var n = records[i].addedNodes[j];
        if (n.nodeType !== 1) continue;
        if (n.matches('[data-jh-wish]')) paint(n);
        else if (n.querySelector('[data-jh-wish]')) paintAll(n);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
  paintAll();

  /* ---------- /pages/wishlist ---------- */
  var page = document.querySelector('[data-jh-wishlist-page]');
  if (!page) return;
  var root = page.getAttribute('data-root') || '/';
  var fmt = page.getAttribute('data-money-format') || '€{{amount_with_comma_separator}}';
  var grid = page.querySelector('[data-jh-wl-grid]');
  var empty = page.querySelector('[data-jh-wl-empty]');
  var count = page.querySelector('[data-jh-wl-count]');
  var shareBtn = page.querySelector('[data-jh-wl-share]');
  var saveAllBtn = page.querySelector('[data-jh-wl-saveall]');
  var addAllBtn = page.querySelector('[data-jh-wl-addall]');
  var status = page.querySelector('[data-jh-wl-status]');
  var cache = {};

  var params = new URLSearchParams(location.search);
  var sharedList = parseShare(params.get('items'));
  var shared = sharedList.length > 0;

  function money(cents) {
    var n = (cents || 0) / 100;
    function sep(dec, th, d) {
      var parts = n.toFixed(d).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts.join(dec);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_with_comma_separator') return sep(',', '.', 2);
      if (k === 'amount_no_decimals') return sep('.', ',', 0);
      if (k === 'amount_no_decimals_with_comma_separator') return sep(',', '.', 0);
      if (k === 'amount_with_apostrophe_separator') return sep('.', "'", 2);
      return sep('.', ',', 2);
    });
  }
  function img(src, w) {
    if (!src) return '';
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function load(handle) {
    if (cache[handle]) return cache[handle];
    cache[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return cache[handle];
  }

  // Same split as snippets/jhilke-title-tiers.liquid: the name, then the rest of the SEO title smaller.
  function tiers(title) {
    var parts = String(title || '').split(' · ');
    var out = '<span class="jh-tt__main">' + esc(parts[0]) + '</span>';
    if (parts.length > 1) out += '<span class="jh-tt__sub"><span class="jh-tt__sep"> · </span>' + esc(parts.slice(1).join(' · ')) + '</span>';
    return out;
  }
  function variantOf(p, id) {
    if (!id || !p.variants) return null;
    for (var i = 0; i < p.variants.length; i++) if (String(p.variants[i].id) === String(id)) return p.variants[i];
    return null;
  }
  function absUrl(src) { return src ? (src.indexOf('//') === 0 ? 'https:' + src : src) : ''; }
  function card(p, item) {
    var vr = variantOf(p, item.v);
    var url = root + 'products/' + p.handle + (vr ? '?variant=' + encodeURIComponent(vr.id) : '');
    var from = !vr && p.price_varies ? (german ? 'ab ' : 'From ') : '';
    var src = absUrl(vr && vr.featured_image && vr.featured_image.src ? vr.featured_image.src : p.featured_image);
    var vTitle = vr && vr.title && vr.title !== 'Default Title' ? vr.title : '';
    var avail = vr ? vr.available : p.available;
    var price = vr ? vr.price : (p.price_min || p.price);
    var action = '';
    if (!avail) action = '';
    else if (vr) action = '<button type="button" class="jh-btn jh-btn--primary jh-wl__add" data-jh-wl-add="' + esc(vr.id) + '" data-jh-wl-name="' + esc(p.title.split(' · ')[0]) + '">' + esc(T.addCart) + '<span class="visually-hidden"> ' + esc(p.title.split(' · ')[0]) + '</span></button>';
    else action = '<a class="jh-btn jh-btn--secondary jh-wl__add" href="' + esc(url) + '">' + esc(T.chooseSize) + '<span class="visually-hidden"> ' + esc(p.title.split(' · ')[0]) + '</span></a>';
    return '<li class="jh-wl__item">' +
      '<a class="jh-wl__media" href="' + esc(url) + '" tabindex="-1" aria-hidden="true">' +
        (src ? '<img src="' + esc(img(src, 480)) + '" srcset="' + esc(img(src, 320)) + ' 320w, ' + esc(img(src, 480)) + ' 480w, ' + esc(img(src, 720)) + ' 720w" sizes="(max-width: 749px) 46vw, 280px" width="480" height="600" loading="lazy" alt="">' : '') +
      '</a>' +
      '<div class="jh-wl__body">' +
        '<a class="jh-wl__title" href="' + esc(url) + '">' + tiers(p.title) + '</a>' +
        (vTitle ? '<p class="jh-wl__variant">' + esc(vTitle) + '</p>' : '') +
        '<p class="jh-wl__price">' + (avail ? esc(from + money(price)) : esc(T.soldOut)) + '</p>' +
        (shared ? '' : '<button type="button" class="jh-wl__remove" data-jh-wl-remove="' + esc(p.handle) + '">' + esc(T.removeBtn) + '<span class="visually-hidden"> ' + esc(p.title) + '</span></button>') +
        action +
      '</div></li>';
  }

  var addable = []; // variant ids on screen that can be added to the cart

  function render() {
    var list = shared ? sharedList : read();
    if (count) count.textContent = list.length === 0 ? '' : list.length === 1 ? T.count1 : list.length + T.countN;
    if (shareBtn) shareBtn.hidden = shared || list.length === 0;
    if (saveAllBtn) saveAllBtn.hidden = !shared;
    if (addAllBtn) addAllBtn.hidden = true;
    if (!list.length) { grid.innerHTML = ''; grid.hidden = true; empty.hidden = false; addable = []; return Promise.resolve(); }
    empty.hidden = true;
    page.setAttribute('aria-busy', 'true');
    return Promise.all(list.map(function (e) { return load(e.h); })).then(function (products) {
      var pairs = [];
      products.forEach(function (p, i) { if (p) pairs.push({ p: p, item: list[i] }); });
      if (!shared && pairs.length !== list.length) {
        // A product was deleted or unpublished: drop it so the count stays honest.
        write(pairs.map(function (x) { return x.item; }));
      }
      grid.innerHTML = pairs.map(function (x) { return card(x.p, x.item); }).join('');
      grid.hidden = pairs.length === 0;
      empty.hidden = pairs.length !== 0;
      addable = [];
      pairs.forEach(function (x) {
        var vr = variantOf(x.p, x.item.v);
        if (vr && vr.available) addable.push(String(vr.id));
      });
      if (addAllBtn) addAllBtn.hidden = !shared || addable.length === 0;
      page.removeAttribute('aria-busy');
    });
  }

  /* ---------- add to cart (reuses the theme's cart refresh: shopify:cart:lines-update from @shopify/events) ---------- */
  function setStatus(msg) { if (status) status.textContent = msg; }
  function addToCart(ids, label, btn) {
    var items = ids.map(function (id) { return { id: Number(id), quantity: 1 }; });
    var sectionIds = [];
    document.querySelectorAll('cart-items-component').forEach(function (c) { if (c.dataset && c.dataset.sectionId) sectionIds.push(c.dataset.sectionId); });
    var body = { items: items };
    if (sectionIds.length) body.sections = sectionIds.join(',');
    var hadFocus = !!btn && document.activeElement === btn;
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    function done() {
      if (!btn) return;
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      if (hadFocus && btn.isConnected) btn.focus({ preventScroll: true }); // a disabled button drops focus
    }
    return fetch(root + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (data) {
        if (!r.ok || data.status) throw new Error(data.description || data.message || 'add failed');
        return data;
      });
    }).then(function (data) {
      return fetch(root + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { return { data: data, cart: cart }; });
    }).then(function (res) {
      // Tell the cart drawer, the badge and the header the cart changed, the same way the product form does.
      // The event library is an ES module; assets/jhilke-wishlist-cart.js (a module loaded by the list snippet)
      // exposes it as window.jhCartLinesUpdate. A dynamic import() cannot live here: Shopify's asset minifier
      // rewrites it to require() (QA theme, 15 Oct 2026). Without the bridge, the header's own event refreshes the badge.
      var lines = items.map(function (it) { return { merchandiseId: String(it.id), quantity: 1 }; });
      var bridged = false;
      if (typeof window.jhCartLinesUpdate === 'function') {
        try { window.jhCartLinesUpdate(res.cart, lines, res.data.sections); bridged = true; } catch (err) { bridged = false; }
      }
      if (!bridged) document.dispatchEvent(new CustomEvent('cart:updated', { detail: { itemCount: res.cart.item_count } }));
    }).then(function () {
      setStatus(label);
      done();
    }).catch(function () {
      setStatus(T.failed);
      done();
    });
  }
  grid.addEventListener('click', function (e) {
    var b = e.target.closest('[data-jh-wl-add]');
    if (!b || b.disabled) return;
    var name = b.getAttribute('data-jh-wl-name') || '';
    addToCart([b.getAttribute('data-jh-wl-add')], T.added + name, b);
  });
  if (addAllBtn) addAllBtn.addEventListener('click', function () {
    if (addAllBtn.disabled || !addable.length) return;
    addToCart(addable.slice(), T.addedAll, addAllBtn);
  });

  // Remove, with an Undo in the status line; focus moves to Undo so it is not lost with the card.
  var lastRemoved = null;
  function showUndo(handle, title) {
    if (!status) return;
    status.textContent = T.removed + title + ' ';
    var undo = document.createElement('button');
    undo.type = 'button';
    undo.className = 'jh-wl__undo';
    undo.setAttribute('data-jh-wl-undo', handle);
    undo.textContent = T.undo;
    undo.style.cssText = 'background:none;border:0;min-height:44px;padding:12px 8px;font:inherit;color:inherit;text-decoration:underline;cursor:pointer;';
    status.appendChild(undo);
    undo.focus({ preventScroll: true });
  }
  grid.addEventListener('click', function (e) {
    var b = e.target.closest('[data-jh-wl-remove]');
    if (!b) return;
    var handle = b.getAttribute('data-jh-wl-remove');
    var title = (b.closest('.jh-wl__item') && b.closest('.jh-wl__item').querySelector('.jh-tt__main') || {}).textContent || handle;
    var list = read(), i = indexOfHandle(list, handle);
    if (i === -1) return;
    var item = list.splice(i, 1)[0];
    lastRemoved = { item: item, index: i, title: title };
    write(list);
    showUndo(handle, title);
  });
  if (status) status.addEventListener('click', function (e) {
    var u = e.target.closest('[data-jh-wl-undo]');
    if (!u || !lastRemoved) return;
    var r = lastRemoved, list = read();
    lastRemoved = null;
    if (indexOfHandle(list, r.item.h) === -1) list.splice(Math.min(r.index, list.length), 0, r.item);
    write(list);
    status.textContent = T.back + r.title;
    render().then(function () {
      var link = grid.querySelector('[data-jh-wl-remove="' + CSS.escape(r.item.h) + '"]');
      var title = link && link.closest('.jh-wl__item') && link.closest('.jh-wl__item').querySelector('.jh-wl__title');
      if (title) title.focus({ preventScroll: true });
    });
  });
  if (shareBtn) shareBtn.addEventListener('click', function () {
    // Always the public list page, never the account tab (which needs a login).
    var url = location.origin + root + 'pages/wishlist?items=' + buildShare(read());
    var done = function () { if (status) status.textContent = T.copied; };
    // When copying is not possible, show the link so it can be copied by hand.
    var fallback = function () { if (status) status.textContent = T.copyThis + url; };
    if (navigator.share) {
      navigator.share({ title: document.title, url: url }).catch(function (err) {
        if (!err || err.name !== 'AbortError') fallback();
      });
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(done).catch(fallback);
    } else {
      fallback();
    }
  });
  if (saveAllBtn) saveAllBtn.addEventListener('click', function () {
    var list = read();
    // Keep the shared variants; an item already on this list keeps the choice made here.
    sharedList.forEach(function (e) { if (indexOfHandle(list, e.h) === -1) list.push(e); });
    write(list);
    location.href = location.pathname;
  });
  if (shared) {
    var h = page.querySelector('[data-jh-wl-heading]');
    if (h) h.textContent = T.shared;
  }
  document.addEventListener('jh:wishlist', function () { if (!shared) render(); });
  render();
})();
